import ApiService from '@/services/ApiService';
import ApiEndpoints from '@/config/ApiEndpoints';
import { url } from '@/helpers/UrlHelpers';

export default class createSpecialDates {
    apiService

    constructor(apiService = null) {
        this.apiService = apiService || new ApiService(process.env.VUE_APP_API_URL);
        this.apiService.enableAuth();
    }

    async handle(payload) {
        const apiUrl = url(ApiEndpoints['users.createSpecialDates']);
        let request = await this.apiService
            .post(apiUrl, payload)
            .catch((error) => error.response.data);

        return request;
    }
}
